import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import { ContainerComponent } from '../../../shared/components/container/container.component';

@Component({
  selector: '[references]',
  imports: [ContainerComponent, NgbAccordionModule],
  templateUrl: './references.html',
  styleUrl: './references.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class References { }
